import DateInput from "../../../components/common/inputs/DateInput";

function LoanCountReportFilter({ filterDataHandler }) {
  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full flex flex-col sm:flex-row gap-6">
        <div className="flex flex-wrap items-center justify-center gap-2 mt-1">
          <DateInput
            label={"از تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, from: e })}
          />
          <DateInput
            label={"تا تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, to: e })}
          />
        </div>
      </div>
    </div>
  );
}

export default LoanCountReportFilter;
